<div class="container-fluid py-4 bg-light min-vh-100">
  
  <!-- Header -->
  <div class="row mb-4">
    <div class="col-12">
      <div class="d-flex justify-content-between align-items-center flex-wrap gap-2">
        <h1 class="mb-0 title">
          <i class="bi bi-journal-text me-2"></i>
          {{ 'SALE_LOGS' | translate }}
        </h1>
        <div class="d-flex gap-2 hidden">
          <button class="btn btn-outline-primary" (click)="loadLogs()" [disabled]="loading">
            <i class="bi bi-arrow-clockwise me-1" [class.spinner-border]="loading"></i>
            {{ loading ? 'Cargando...' : 'Actualizar' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Error Alert -->
  <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show" role="alert">
    <i class="bi bi-exclamation-triangle me-2"></i>{{ errorMessage }}
    <button type="button" class="btn-close" (click)="errorMessage = null"></button>
  </div>

  <!-- Filters Card -->
  <div class="card mb-4 shadow-sm border-0">
    <div class="card-header bg-white py-3">
      <h5 class="mb-0 text-secondary">
        <i class="bi bi-funnel me-2"></i>
        {{ 'SEARCH_FILTERS' | translate }}
      </h5>
    </div>
    <div class="card-body">
      <form (ngSubmit)="applyFilters()">
        <div class="row g-3">
          
          <!-- Tipo de Log -->
          <div class="col-md-3">
            <label class="form-label small text-muted">{{ 'LOG_TYPE' | translate }}</label>
            <select class="form-select form-select-sm" [(ngModel)]="filters.logType" name="logType">
              <option value="">{{ 'ALL' | translate }}</option>
              <option value="SALE_PAYMENT_SUCCESS">✅ {{ 'SALE_PAYMENT_SUCCESS' | translate }}</option>
              <option value="SALE_PAYMENT_FAILED">❌ {{ 'SALE_PAYMENT_FAILED' | translate }}</option>
              <option value="SALE_STATE_CHANGED">🔄 {{ 'SALE_STATE_CHANGED' | translate }}</option>
            </select>
          </div>
          
          <!-- Fecha Inicio -->
          <div class="col-md-3">
            <label class="form-label small text-muted">{{ 'START_DATE' | translate }}</label>
            <input type="datetime-local" class="form-control form-control-sm" 
                   [(ngModel)]="filters.startDate" name="startDate">
          </div>
          
          <!-- Fecha Fin -->
          <div class="col-md-3">
            <label class="form-label small text-muted">{{ 'END_DATE' | translate }}</label>
            <input type="datetime-local" class="form-control form-control-sm" 
                   [(ngModel)]="filters.endDate" name="endDate">
          </div>
          
          <!-- Búsqueda -->
          <div class="col-md-3">
            <label class="form-label small text-muted">{{ 'SEARCH' | translate }}</label>
            <input type="text" class="form-control form-control-sm" 
                   [(ngModel)]="filters.search" name="search" 
                   placeholder="Id de Orden, Id Metodo de pago{{ 'SEARCH_LOG_PLACEHOLDER' | translate }}">
          </div>
        </div>
        
        <!-- Filter Actions -->
        <div class="row mt-3">
          <div class="col-12">
            <button type="submit" class="btn primary-btn me-2">
              <i class="bi bi-search me-1"></i>{{ 'APPLY' | translate }}
            </button>
            <button type="button" class="btn remove-btn" (click)="clearFilters()">
              <i class="bi bi-x-circle me-1"></i>{{ 'CLEAR' | translate }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
      <span class="visually-hidden">{{ 'LOADING' | translate }}...</span>
    </div>
    <p class="mt-3 text-muted">{{ 'LOADING_LOGS' | translate }}...</p>
  </div>

  <!-- Empty State -->
  <div *ngIf="!loading && logs.length === 0" class="text-center py-5">
    <i class="bi bi-inbox display-1 text-muted"></i>
    <h4 class="mt-3 text-muted">{{ 'NO_LOGS_FOUND' | translate }}</h4>
    <p class="text-muted">{{ 'RELOAD_PAGE' | translate }}.</p>
  </div>

  <!-- Logs Table -->
  <div *ngIf="!loading && logs.length > 0" class="card shadow-sm border-0">
    
    <!-- Table Header -->
    <div class="card-header bg-white py-3 d-flex justify-content-between align-items-center">
      <h5 class="mb-0 text-secondary">
        <i class="bi bi-list-ul me-2"></i>{{ 'LOGS' | translate }}
      </h5>
      <span class="badge bg-primary rounded-pill">{{ totalLogs }} {{ 'LOGS' | translate }}</span>
    </div>
    
    <!-- Table -->
    <div class="card-body p-0">
      <div class="table-responsive">
        <table class="table table-hover table-striped mb-0 align-middle">
          <thead class="table-light">
            <tr>
              <th class="ps-3" style="width: 70px;">Log Id</th>
              <th>{{ 'SALE_ID' | translate }}</th>
              <th>{{ 'STATUS' | translate }}</th>
              <th>{{ 'DATE' | translate }}</th>
              <th>{{ 'PAYMENT_METHOD' | translate }}</th>
              <th class="text-end pe-3" style="width: 120px;">{{ 'ACTIONS' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let log of logs" 
                [class.table-success]="log.saleLogType === 'SALE_PAYMENT_SUCCESS'"
                [class.table-danger]="log.saleLogType === 'SALE_PAYMENT_FAILED'"
                [class.table-info]="log.saleLogType === 'SALE_STATE_CHANGED'">
              
              <td class="ps-3"><strong class="text-muted">#{{ log.saleLogId }}</strong></td>
              
              <td>
                <span class="badge bg-primary-subtle text-primary-emphasis border border-primary-subtle">
                  {{ log.saleId }}
                </span>
              </td>
              
              <td>
                <span class="badge" [ngClass]="getStatusBadgeClass(log.saleLogType)">
                  <i class="bi" [ngClass]="log.saleLogType === 'SALE_PAYMENT_SUCCESS' ? 'bi-check-circle' : log.saleLogType === 'SALE_STATE_CHANGED' ? 'bi-arrow-repeat' : 'bi-x-circle'"></i>
                  {{ getStatusText(log.saleLogType) }}
                </span>
              </td>
              
              <td class="text-muted small">{{ formatDate(log.dateCreated) }}</td>
              
              <td>
                <span class="badge bg-secondary-subtle text-secondary-emphasis border border-secondary-subtle">
                  #{{ log.paymentTypeId }} - {{log.paymentTypeName}}
                </span>
              </td>
              
              <td class="text-end pe-3">
                <div class="btn-group btn-group-sm">
                  <button class="btn btn-outline-primary" 
                          (click)="toggleExpand(log.saleLogId)"
                          [attr.aria-expanded]="expandedLog === log.saleLogId"
                          title="Ver detalles">
                    <i class="bi" [ngClass]="expandedLog === log.saleLogId ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
                  </button>
                  <button class="btn btn-outline-secondary" 
                          (click)="copyToClipboard(log)"
                          title="Copiar JSON">
                    <i class="bi bi-clipboard"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Expanded Details (per log) -->
    <div *ngFor="let log of logs">
      <div *ngIf="expandedLog === log.saleLogId" class="border-top bg-light">
        <div class="p-3">
          <div class="row g-3">
            
            <!-- Request Payload -->
            <div class="col-lg-6">
              <div class="card h-100 border-primary-subtle">
                <div class="card-header bg-primary-subtle d-flex justify-content-between align-items-center py-2">
                  <small class="fw-semibold text-primary-emphasis">
                    <i class="bi bi-arrow-right-circle me-1"></i>{{ 'REQUEST_DATA' | translate }}
                  </small>
                  <button class="btn btn-sm btn-outline-primary" 
                          (click)="copyToClipboard(log.requestPayload)"
                          [disabled]="isJsonEmpty(log.requestPayload)">
                    <i class="bi bi-clipboard me-1"></i>{{ 'COPY' | translate }}
                  </button>
                </div>
                <div class="card-body p-0">
                  <pre class="m-0 p-3 bg-dark text-light rounded-bottom" 
                       style="max-height: 250px; overflow-y: auto; font-size: 0.75rem;">
                    <code>{{ log.requestPayload | json }}</code>
                  </pre>
                </div>
              </div>
            </div>
            
            <!-- Response Payload -->
            <div class="col-lg-6">
              <div class="card h-100 border-success-subtle">
                <div class="card-header bg-success-subtle d-flex justify-content-between align-items-center py-2">
                  <small class="fw-semibold text-success-emphasis">
                    <i class="bi bi-arrow-left-circle me-1"></i>{{ 'RESPONSE_DATA' | translate }}
                  </small>
                  <button class="btn btn-sm btn-outline-success" 
                          (click)="copyToClipboard(log.responsePayload)"
                          [disabled]="isJsonEmpty(log.responsePayload)">
                    <i class="bi bi-clipboard me-1"></i>{{ 'COPY' | translate }}
                  </button>
                </div>
                <div class="card-body p-0">
                  <pre class="m-0 p-3 bg-dark text-light rounded-bottom" 
                       style="max-height: 250px; overflow-y: auto; font-size: 0.75rem;">
                    <code>{{ log.responsePayload | json }}</code>
                  </pre>
                </div>
              </div>
            </div>
            
            <!-- Customer Snapshot (full width) -->
            <div class="col-12" *ngIf="!isJsonEmpty(log.customerSnapshot)">
              <div class="card border-info-subtle">
                <div class="card-header bg-info-subtle py-2">
                  <small class="fw-semibold text-info-emphasis">
                    <i class="bi bi-person me-1"></i>{{ 'CUSTOMER_SNAPSHOT' | translate }}
                  </small>
                </div>
                <div class="card-body p-0">
                  <pre class="m-0 p-3 bg-dark text-light rounded-bottom" 
                       style="max-height: 200px; overflow-y: auto; font-size: 0.75rem;">
                    <code>{{ log.customerSnapshot | json }}</code>
                  </pre>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
    </div>
    
    <!-- Pagination -->
    <div class="card-footer bg-white py-3" *ngIf="totalPages > 1">
      <nav aria-label="Paginación de logs">
        <ul class="pagination justify-content-center mb-0">
          
          <!-- Previous -->
          <li class="page-item" [class.disabled]="currentPage === 1">
            <button class="page-link" (click)="goToPage(currentPage - 1)">
              <i class="bi bi-chevron-left"></i>
            </button>
          </li>
          
          <!-- Page Numbers -->
          <li class="page-item" *ngFor="let page of getPagesArray()" 
              [class.active]="currentPage === page">
            <button class="page-link" (click)="goToPage(page)">{{ page }}</button>
          </li>
          
          <!-- Next -->
          <li class="page-item" [class.disabled]="currentPage === totalPages">
            <button class="page-link" (click)="goToPage(currentPage + 1)">
              <i class="bi bi-chevron-right"></i>
            </button>
          </li>
          
        </ul>
      </nav>
    </div>
    
  </div>
  
</div>